(() => {
  if (window.jtCatalogNavigationReady) return;
  window.jtCatalogNavigationReady = true;
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-jt-nav][open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-jt-nav][open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
})();
